import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ChevronRightIcon, FileTextIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PilatesHero() {
  const reduceMotion = useReducedMotion();
  return <>
      <div className="bg-padel-lime px-4 py-2 text-center text-xs font-black tracking-widest text-padel-dark sm:text-sm" data-id="element-215" data-mp="2gtq4wy2a968a">
        ¡OFERTA DE LANZAMIENTO! 50% OFF - SOLO POR HOY.
      </div>
      <section className="relative overflow-hidden bg-padel-dark px-4 pb-14 pt-10 sm:pb-20 sm:pt-16" data-id="element-216" data-mp="28161lkb1qdh4">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/8ece9af6-cee3-488a-abbe-c91f06710bec.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-217" data-mp="2322y44apsfb9" />
        <div className="absolute inset-0 bg-padel-dark/80" aria-hidden="true" data-id="element-218" data-mp="1t3dqr5gg2d99" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-padel-dark to-transparent" aria-hidden="true" data-id="element-219" data-mp="1p3czulc5s9lb" />

        <div className="relative mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-220" data-mp="3vb0s9p6z4vwl">
          {/* Marca */}
          <FadeIn data-id="element-221" data-mp="3gmmptfdgz9gk">
            <span className="inline-flex items-center gap-2 rounded-full border border-padel-muted bg-padel-surface/90 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-gray-300" data-id="element-222" data-mp="3gn5ye5h8clhx">
              <span className="text-padel-lime" data-id="element-223" data-mp="d6fm58v21c7s">💪</span> Stock Digital™
            </span>
          </FadeIn>

          {/* Título */}
          <FadeIn delay={0.08} data-id="element-224" data-mp="i3piz9krwq5n">
            <h1 className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-225" data-mp="44znfydlqyje">
              DEJÁ DE REGALAR TU TIEMPO Y EMPEZÁ A TRABAJAR COMO UN{' '}
              <span className="block text-padel-lime drop-shadow-[0_0_30px_rgba(197,255,61,0.28)]" data-id="element-226" data-mp="2ouf6u8ahrkz0">
                PROFE DE ÉLITE
              </span>
            </h1>
          </FadeIn>

          {/* Subtítulo */}
          <FadeIn delay={0.14} data-id="element-227" data-mp="zcruzebg1tmt">
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg" data-id="element-228" data-mp="zd1o3arscgwq">
              No más domingos perdidos buscando videitos en Instagram. Llevate
              el sistema probado para llenar tu agenda, retener a tus alumnos y
              cobrar lo que realmente valés.
            </p>
          </FadeIn>

          {/* Mockup */}
          <FadeIn delay={0.2} className="w-full" data-id="element-229" data-mp="god1mkdnm3iu">
            <motion.div animate={reduceMotion ? undefined : {
            y: [0, -10, 0]
          }} transition={reduceMotion ? undefined : {
            duration: 5,
            ease: 'easeInOut',
            repeat: Infinity
          }} className="relative mx-auto mt-8 w-full max-w-[19rem] sm:max-w-sm" data-id="element-230" data-mp="gkz2rm478cg5">
              <div className="absolute inset-6 rounded-full bg-padel-lime/25 blur-3xl" aria-hidden="true" data-id="element-231" data-mp="212n5z3kn8biu" />
              <img src="https://cdn.magicpatterns.com/uploads/k8DuDoNSCcuTNBKRMxRtk8/ChatGPT_Image_23_jul_2026,_03_23_57_p.m..png" alt="Método Pro-Pádel: libro, ejercicios e imágenes de golpes" className="relative w-full object-contain drop-shadow-[0_25px_50px_rgba(0,0,0,0.6)]" data-id="element-232" data-mp="24lcm44bp5qr1" />
            </motion.div>
          </FadeIn>

          {/* Botón de oferta */}
          <FadeIn delay={0.26} className="w-full" data-id="element-233" data-mp="1ln055wejnckw">
            <button type="button" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="mx-auto mt-8 flex w-full max-w-md flex-col items-center justify-center rounded-2xl bg-padel-lime px-6 py-4 font-display text-padel-dark shadow-[0_0_35px_rgba(197,255,61,0.28)] transition-transform hover:scale-[1.02] active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-234" data-mp="1lol2tuw5nbmz">
              <span className="flex items-center gap-2 text-lg font-black leading-none sm:text-xl" data-id="element-235" data-mp="iue9muovawo4">
                QUIERO EL MÉTODO AHORA
                <ChevronRightIcon className="h-6 w-6" strokeWidth={3} data-id="element-236" data-mp="wup19zy04fac" />
              </span>
              <span className="mt-1.5 text-sm font-bold text-padel-dark/75 sm:text-base" data-id="element-237" data-mp="rsrcyraquuaj">
                (ACCESO INMEDIATO)
              </span>
            </button>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-gray-300 sm:text-sm" data-id="element-238" data-mp="11ta0px5fiuxq">
              <span className="inline-flex items-center gap-1.5" data-id="element-239" data-mp="1flzoo74iq9xh">
                <FileTextIcon className="h-4 w-4 text-padel-lime" data-id="element-240" data-mp="1bjcva1s78gy6" />
                100% PDF
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-241" data-mp="1piktosgjfl1b">
                <ZapIcon className="h-4 w-4 text-padel-lime" data-id="element-242" data-mp="1kjrfextffq03" />
                Acceso en 5 min
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-243" data-mp="245tbwd89kqms">
                <BookOpenIcon className="h-4 w-4 text-padel-lime" data-id="element-244" data-mp="293l0ax9p9um8" />
                Todos los niveles
              </span>
            </div>

            <div className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] font-semibold text-gray-500 sm:text-xs" data-id="element-245" data-mp="1u5sp2hb6rsdu">
              <span data-id="element-246" data-mp="1lea8i5abvak8">🛡️ Garantía 7 días</span>
              <span data-id="element-247" data-mp="1ld8upt1xg9yt">🔒 Pago seguro</span>
              <span data-id="element-248" data-mp="1lcfmennblcek">💳 Mercado Pago</span>
            </div>
          </FadeIn>
        </div>
      </section>
    </>;
}